import React, { useState } from 'react';
import { Row, Col, Form, InputGroup, Button } from 'react-bootstrap';

const defaultFilters = {
  search: '', status: 'all', paymentStatus: 'all',
  vendor: 'all', dateRange: 'last30days', startDate: '', endDate: '',
};

const AdmHotelBookingFilters = ({ vendors = [], onFilterChange }) => {

  const [filters, setFilters] = useState(defaultFilters);

  const update = (field, value) => {
    const updated = { ...filters, [field]: value };
    setFilters(updated);
    onFilterChange?.(updated);
  };

  const handleDateRange = (range) => {
    const today = new Date();
    let startDate = '', endDate = '';
    if (range === 'today') {
      startDate = endDate = today.toISOString().split('T')[0];
    } else if (range === 'last7days') {
      endDate   = today.toISOString().split('T')[0];
      startDate = new Date(today.setDate(today.getDate() - 7)).toISOString().split('T')[0];
    } else if (range === 'last30days') {
      endDate   = new Date().toISOString().split('T')[0];
      startDate = new Date(today.setDate(today.getDate() - 30)).toISOString().split('T')[0];
    } else if (range === 'thisMonth') {
      const now = new Date();
      startDate = new Date(now.getFullYear(), now.getMonth(), 1).toISOString().split('T')[0];
      endDate   = now.toISOString().split('T')[0];
    }
    const updated = { ...filters, dateRange: range, startDate, endDate };
    setFilters(updated);
    onFilterChange?.(updated);
  };

  const reset = () => { setFilters(defaultFilters); onFilterChange?.(defaultFilters); };

  return (
    <div className="adm-bkd-filter-bar">
      <Row className="g-2 align-items-end">

        <Col xs={12} md={3}>
          <Form.Label className="adm-bkd-filter-label">Search</Form.Label>
          <InputGroup>
            <InputGroup.Text className="adm-bkd-filter-icon">
              <i className="bi bi-search" />
            </InputGroup.Text>
            <Form.Control
              type="text"
              placeholder="Booking ID, customer, hotel…"
              value={filters.search}
              onChange={e => update('search', e.target.value)}
              className="adm-bkd-filter-input"
            />
          </InputGroup>
        </Col>

        <Col xs={6} md={2}>
          <Form.Label className="adm-bkd-filter-label">Booking Status</Form.Label>
          <Form.Select
            value={filters.status}
            onChange={e => update('status', e.target.value)}
            className="adm-bkd-filter-select"
          >
            <option value="all">All Status</option>
            <option value="pending">Pending</option>
            <option value="confirmed">Confirmed</option>
            <option value="completed">Completed</option>
            <option value="cancelled">Cancelled</option>
          </Form.Select>
        </Col>

        <Col xs={6} md={2}>
          <Form.Label className="adm-bkd-filter-label">Payment</Form.Label>
          <Form.Select
            value={filters.paymentStatus}
            onChange={e => update('paymentStatus', e.target.value)}
            className="adm-bkd-filter-select"
          >
            <option value="all">All Payments</option>
            <option value="paid">Paid</option>
            <option value="unpaid">Unpaid</option>
            <option value="refunded">Refunded</option>
            <option value="partial_refund">Partial Refund</option>
          </Form.Select>
        </Col>

        <Col xs={6} md={2}>
          <Form.Label className="adm-bkd-filter-label">Vendor</Form.Label>
          <Form.Select
            value={filters.vendor}
            onChange={e => update('vendor', e.target.value)}
            className="adm-bkd-filter-select"
          >
            <option value="all">All Vendors</option>
            {vendors.map(v => (
              <option key={v.id} value={v.id}>{v.name}</option>
            ))}
          </Form.Select>
        </Col>

        <Col xs={6} md={2}>
          <Form.Label className="adm-bkd-filter-label">Date Range</Form.Label>
          <Form.Select
            value={filters.dateRange}
            onChange={e => handleDateRange(e.target.value)}
            className="adm-bkd-filter-select"
          >
            <option value="today">Today</option>
            <option value="last7days">Last 7 Days</option>
            <option value="last30days">Last 30 Days</option>
            <option value="thisMonth">This Month</option>
            <option value="custom">Custom</option>
          </Form.Select>
        </Col>

        <Col xs={12} md={1}>
          <Button
            variant="outline-secondary"
            onClick={reset}
            className="adm-bkd-reset-btn w-100"
          >
            <i className="bi bi-arrow-clockwise me-1" /> Reset
          </Button>
        </Col>
      </Row>

      {filters.dateRange === 'custom' && (
        <Row className="g-2 mt-1">
          <Col xs={12} md={3}>
            <Form.Label className="adm-bkd-filter-label">Start Date</Form.Label>
            <Form.Control
              type="date" value={filters.startDate}
              onChange={e => update('startDate', e.target.value)}
              className="adm-bkd-filter-input"
            />
          </Col>
          <Col xs={12} md={3}>
            <Form.Label className="adm-bkd-filter-label">End Date</Form.Label>
            <Form.Control
              type="date" value={filters.endDate}
              onChange={e => update('endDate', e.target.value)}
              className="adm-bkd-filter-input"
            />
          </Col>
        </Row>
      )}
    </div>
  );
};

export default AdmHotelBookingFilters;